export const ADMIN_ROUTE = 'stjornandi'
